import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Paper, BorrowerData } from 'components';
import { jsx as ___EmotionJSX } from "@emotion/react";

var CreditBorrowerTab = function CreditBorrowerTab(_ref) {
  var borrower = _ref.borrower;
  return ___EmotionJSX(Row, {
    justify: "space-between",
    align: "center",
    backgroundColor: "white"
  }, ___EmotionJSX(Col, {
    sm: 12
  }, ___EmotionJSX(Paper, {
    header: function header(_ref2) {
      var css = _ref2.css;
      return ___EmotionJSX("div", {
        css: css
      }, ___EmotionJSX("h5", null, "\u0418\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F \u0437\u0430 \u043A\u0440\u0435\u0434\u0438\u0442\u043E\u043F\u043E\u043B\u0443\u0447\u0430\u0442\u0435\u043B"));
    },
    margin: "0 0 2em 0"
  }, ___EmotionJSX(BorrowerData, {
    data: borrower
  }))));
};

CreditBorrowerTab.propTypes = {
  borrower: PropTypes.object
};
export default CreditBorrowerTab;